// @ts-nocheck
(function() {
  'use strict';
  
  const MobileBurgerMenu = {
    elements: {
      burger: null,
      mobileNav: null,
      body: document.body
    },
    
    config: {
      mobileBreakpoint: 768,
      classes: {
        open: 'open',
        active: 'none-active',
        mobileNavOpen: 'mobile-nav-open',
        mobileNavigation: 'mobile-navigation',
        mobileSubmenu: 'mobile-submenu',
        mobileSubmenuToggle: 'mobile-submenu-toggle'
      }
    },
    
    init() {
      this.cacheDOMElements();
      if (!this.elements.burger) return;
      
      this.elements.mobileNav = this.elements.mobileNav || this.createMobileNavigation();
      this.bindEvents();
    },
    
    cacheDOMElements() {
      this.elements.burger = document.getElementById('burger-button-on-header');
      this.elements.mobileNav = document.querySelector(`.${this.config.classes.mobileNavigation}`);
    },
    
    isMobile() {
      return window.innerWidth <= this.config.mobileBreakpoint;
    },
    
    bindEvents() {
      this.elements.burger.addEventListener('click', this.handleBurgerClick.bind(this));
      document.addEventListener('click', this.handleOutsideClick.bind(this));
      window.addEventListener('resize', this.handleResize.bind(this));
    },
    
    handleBurgerClick(e) {
      e.preventDefault();
      if (!this.isMobile()) return;
      
      this.elements.burger.classList.contains(this.config.classes.open) 
        ? this.closeMobileMenu() 
        : this.openMobileMenu();
    },
    
    handleOutsideClick(e) {
      if (!this.isMobile()) return;
      
      const isClickInsideNav = this.elements.mobileNav.contains(e.target);
      const isClickOnBurger = this.elements.burger.contains(e.target);
      
      if (!isClickInsideNav && !isClickOnBurger && this.elements.burger.classList.contains(this.config.classes.open)) {
        this.closeMobileMenu();
      }
    },
    
    handleResize() {
      if (!this.isMobile() && this.elements.burger.classList.contains(this.config.classes.open)) {
        this.closeMobileMenu();
      }
    },
    
    createMobileNavigation() {
      const mobileNav = document.createElement('div');
      mobileNav.className = this.config.classes.mobileNavigation;
      mobileNav.innerHTML = `
        <div class="mobile-nav-content">
          <div class="mobile-nav-menu"></div>
        </div>
      `;
      
      this.elements.body.appendChild(mobileNav);
      this.populateMobileNavigation(mobileNav);
      return mobileNav;
    },
    
    populateMobileNavigation(mobileNav) {
      const submenus = document.querySelectorAll('.submenu-dk');
      const mobileNavMenu = mobileNav.querySelector('.mobile-nav-menu');
      
      submenus.forEach((submenu, index) => {
        const { toggleBtn, mobileSubmenu } = this.createSubmenuElements(submenu, index);
        mobileNavMenu.appendChild(toggleBtn);
        mobileNavMenu.appendChild(mobileSubmenu);
      });
    },
    
    createSubmenuElements(submenu, index) {
      const mobileSubmenu = submenu.cloneNode(true);
      mobileSubmenu.classList.add(this.config.classes.mobileSubmenu, `mobile-submenu-${index}`);
      
      const toggleBtn = document.createElement('button');
      toggleBtn.className = this.config.classes.mobileSubmenuToggle;
      toggleBtn.textContent = submenu.getAttribute('data-title') || `Menu ${index + 1}`;
      toggleBtn.setAttribute('data-submenu', index);
      toggleBtn.addEventListener('click', () => this.toggleMobileSubmenu(index));
      
      return { toggleBtn, mobileSubmenu };
    },
    
    openMobileMenu() {
      this.elements.burger.classList.add(this.config.classes.open);
      this.elements.body.classList.add(this.config.classes.mobileNavOpen);
      this.elements.mobileNav.classList.add(this.config.classes.active);
      this.elements.body.style.overflow = 'hidden';
    },
    
    closeMobileMenu() {
      this.elements.burger.classList.remove(this.config.classes.open);
      this.elements.body.classList.remove(this.config.classes.mobileNavOpen);
      this.elements.mobileNav.classList.remove(this.config.classes.active);
      this.elements.body.style.overflow = '';
      this.closeAllSubmenus();
    },
    
    closeAllSubmenus() {
      const openSubmenus = document.querySelectorAll(`.${this.config.classes.mobileSubmenu}.${this.config.classes.active}`);
      openSubmenus.forEach(submenu => submenu.classList.remove(this.config.classes.active));
    },
    
    toggleMobileSubmenu(index) {
      const submenu = document.querySelector(`.mobile-submenu-${index}`);
      const toggleBtn = document.querySelector(`[data-submenu="${index}"]`);
      
      if (!submenu) return;
      
      const isOpen = submenu.classList.contains(this.config.classes.active);
      
      this.closeAllSubmenus();
      document.querySelectorAll(`.${this.config.classes.mobileSubmenuToggle}`)
        .forEach(btn => btn.classList.remove(this.config.classes.active));
      
      if (!isOpen) {
        submenu.classList.add(this.config.classes.active);
        toggleBtn.classList.add(this.config.classes.active);
      }
    }
  };

  const SearchToggle = {
    init() {
      this.bindEvents();
    },

    bindEvents() {
      // Using jQuery for consistency with your existing code
      $("[data-search-trigger]").on("click", this.handleSearchToggle.bind(this));
    },

    handleSearchToggle(e) {
      e.preventDefault();
      $("#search-bar-d").slideToggle();
      $("#search-input").get(0).focus();
    }
  };

  const ProductSwiperManager = {
    initialized: new Set(), 

    init() {
      this.initializeAllSwipers();
      this.observeProductGrid();
      
      window.addEventListener('load', () => {
        setTimeout(() => this.initializeAllSwipers(), 500);
      });
    },

    observeProductGrid() {
      const observer = new MutationObserver((mutations) => {
        let shouldReinit = false;
        
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1) { 
              if (node.classList?.contains('product-grid__item') || 
                  node.querySelector?.('[class*="swiper-"]')) {
                shouldReinit = true;
              }
            }
          });
        });
        
        if (shouldReinit) {
          setTimeout(() => this.initializeAllSwipers(), 100);
        }
      });

      const targetNode = document.querySelector('#MainContent, main, body');
      if (targetNode) {
        observer.observe(targetNode, {
          childList: true,
          subtree: true
        });
      }
    },

    initializeAllSwipers() {
      if (typeof Swiper === 'undefined') {
        setTimeout(() => this.initializeAllSwipers(), 200);
        return;
      }

      this.initializeProductCardSwipers();
      this.initializeDetailCardSwipers();
    },

    initializeProductCardSwipers() {
      const swiperElements = document.querySelectorAll('[class*="product-image-swiper-"]');
      
      swiperElements.forEach((swiperEl) => {
        const classList = Array.from(swiperEl.classList);
        const swiperClass = classList.find(cls => cls.startsWith('product-image-swiper-'));
        const productId = swiperClass ? swiperClass.replace('product-image-swiper-', '') : '';
        
        if (!productId) return;
        
        const uniqueKey = `product-${productId}`;
        
        if (swiperEl.swiper || this.initialized.has(uniqueKey)) return;
        
        try {
          new Swiper(swiperEl, {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: false,
            pagination: {
              el: `.product-image-swiper-pagination-${productId}`,
              clickable: true,
              bulletClass: 'swiper-pagination-bullet',
              bulletActiveClass: 'swiper-pagination-bullet-active',
            },
            lazy: {
              loadPrevNext: true,
            },
            observer: true,
            observeParents: true,
            speed: 300,
          });
          
          this.initialized.add(uniqueKey);
        } catch (error) {
          // console.error('Error initializing product swiper:', productId, error);
        }
      });
    },

    initializeDetailCardSwipers() {
      const detailSwiperElements = document.querySelectorAll('[class*="detail-card-swiper-"]');
      
      detailSwiperElements.forEach((swiperEl) => {
        const classList = Array.from(swiperEl.classList);
        const swiperClass = classList.find(cls => cls.startsWith('detail-card-swiper-'));
        const productId = swiperClass ? swiperClass.replace('detail-card-swiper-', '') : '';
        
        if (!productId) return;
        
        const uniqueKey = `detail-${productId}`;
        
        if (swiperEl.swiper || this.initialized.has(uniqueKey)) return;
        
        try {
          new Swiper(swiperEl, {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: false,
            pagination: {
              el: `.detail-card-swiper-pagination-${productId}`,
              clickable: true,
              bulletClass: 'swiper-pagination-bullet',
              bulletActiveClass: 'swiper-pagination-bullet-active',
            },
            lazy: {
              loadPrevNext: true,
            },
            observer: true,
            observeParents: true,
            speed: 300,
          });
          
          this.initialized.add(uniqueKey);
        } catch (error) {
          // console.error('Error initializing detail card swiper:', productId, error);
        }
      });
    },
    reinitialize() {
      this.initializeAllSwipers();
    }
  };

  window.ProductSwiperManager = ProductSwiperManager;
  
  document.addEventListener('DOMContentLoaded', () => {
    MobileBurgerMenu.init();
    SearchToggle.init();
    ProductSwiperManager.init();
  });
})();